import React from 'react';
import { connect } from 'react-redux';

export class ModuleAccess extends React.Component {
    render() {
        const access = parseInt(this.props.access);
        return this.props.moduleAccess && this.props.moduleAccess >= access ? this.props.children : <div display="none"></div>;

    } 
}

function mapStateToProps(state, ownProps) {
    if (ownProps.moduleName)
        return {
            moduleAccess: ownProps.moduleName && ownProps.moduleName !== ""
                ? state.app.appModulesAccess[ownProps.moduleName]
                : false
        };
};


export default connect(mapStateToProps)(ModuleAccess);